export default __webpack_public_path__ + "static/5-4d779b4d71a8698e5606a64532ef7e64.jpg";